export const bytesToSize = (bytes) => {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

// CV text extracted from uploaded PDFs is full of hard line breaks (which make
// a paragraph stair-step across lines) and "smart" punctuation the CV font
// can't render - it shows as boxes. Two sources: proper Unicode smart quotes
// (U+2018 etc.) and, more often, Windows-1252 punctuation mis-decoded into the
// C1 control range (0x91-0x97) by the text extractor. Fold both down to plain
// ASCII and collapse whitespace so it renders as a clean paragraph.
export const cleanProfileText = (text) => {
    if (!text) return text;
    let out = "";
    for (const ch of String(text)) {
        const code = ch.codePointAt(0);
        if (code === 0x91 || code === 0x92 || (code >= 0x2018 && code <= 0x201B) || code === 0x2032) {
            out += "'";
        } else if (code === 0x93 || code === 0x94 || (code >= 0x201C && code <= 0x201F) || code === 0x2033) {
            out += '"';
        } else if (code === 0x96 || code === 0x97 || (code >= 0x2013 && code <= 0x2015)) {
            out += "-";
        } else if (code === 0x85 || code === 0x2026) {
            out += "...";
        } else if (code === 0x95 || code === 0x2022) {
            out += " ";
        } else if (code === 0xA0) {
            out += " ";
        } else if (code < 0x20 || (code >= 0x7F && code <= 0x9F) || (code >= 0xE000 && code <= 0xF8FF)) {
            out += " ";
        } else {
            out += ch;
        }
    }
    return out.replace(/\s+/g, " ").trim();
}
